module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[37]402.1deb0a4.woff2";